import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography, Paper } from "@mui/material";
import { toast } from "react-toastify";
import { useMicroPractices } from "../../hooks/useRedux";
import MicroPracticeForm from "./MicroPracticeForm";
import { MicroPractice } from "../../store/slices/types";

const AddMicroPractice: React.FC = () => {
  const navigate = useNavigate();
  const { createMicroPractice } = useMicroPractices();

  const handleSave = async (microPracticeData: Partial<MicroPractice>) => {
    try {
      const newMicroPractice = {
        title: microPracticeData.title || "",
        description: microPracticeData.description || "",
        duration: microPracticeData.duration || 0,
        category: microPracticeData.category || "Breathe & Reset",
        instructions: microPracticeData.instructions || [],
        benefits: microPracticeData.benefits || [],
        isActive:
          microPracticeData.isActive !== undefined
            ? microPracticeData.isActive
            : true,
        color: microPracticeData.color || "#667eea",
        tags: microPracticeData.tags || [],
        difficulty: microPracticeData.difficulty || "beginner",
        createdBy: "admin",
        createdAt: Date.now(),
        updatedAt: Date.now(),
      };

      await createMicroPractice(newMicroPractice);
      toast.success("micro practice is created");
      navigate("/micro-practices");
    } catch (error) {
      console.error("Failed to create micro practice:", error);
      toast.error(
        `❌ Failed to create micro practice: ${
          error instanceof Error ? error.message : "Unknown error"
        }`
      );
    }
  };

  const handleCancel = () => {
    navigate("/micro-practices");
  };

  return (
    <Box>
      <Paper
        sx={{
          p: 4,
          borderRadius: 3,
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          color: "white",
          mb: 4,
        }}
      >
        <Typography variant='h4' fontWeight='700' gutterBottom>
          Create New Micro Practice
        </Typography>
        <Typography variant='body1' sx={{ opacity: 0.9 }}>
          Add a new quick wellness practice to your library
        </Typography>
      </Paper>

      <Paper sx={{ p: 4, borderRadius: 3 }}>
        <MicroPracticeForm
          microPractice={null}
          onSave={handleSave}
          onCancel={handleCancel}
        />
      </Paper>
    </Box>
  );
};

export default AddMicroPractice;

